var exports = {
  "k": "xcc377c0b--c87631--container",
};

module.exports = exports;
